export { default as Collapsible } from './Collapsible';
